export default __webpack_public_path__ + "static/media/evening.c2101b19.svg";